import React from 'react';
import { Table, Card, Tag, Row, Col, Statistic, DatePicker, Button, Space } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const commissions = [
  { key: '1', agent: '深圳割草机科技', period: '2026-03', revenue: 42000, rate: '15%', commission: 6300, status: 'paid' },
  { key: '2', agent: '武汉IoT平台公司', period: '2026-03', revenue: 35600, rate: '15%', commission: 5340, status: 'pending' },
  { key: '3', agent: '上海安防系统集成商', period: '2026-03', revenue: 28900, rate: '12%', commission: 3468, status: 'pending' },
  { key: '4', agent: '深圳割草机科技', period: '2026-02', revenue: 38200, rate: '15%', commission: 5730, status: 'paid' },
  { key: '5', agent: '武汉IoT平台公司', period: '2026-02', revenue: 31400, rate: '15%', commission: 4710, status: 'paid' },
];

const Commission: React.FC = () => (
  <div style={{ padding: 16 }}>
    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
      {[
        { title: '本月应付分润', value: '¥15,108', color: '#fa8c16' },
        { title: '本月已结算', value: '¥12,030', color: '#52c41a' },
        { title: '待结算', value: '¥8,808', color: '#ff4d4f' },
        { title: '累计分润', value: '¥168,400', color: '#1890ff' },
      ].map((item, i) => (
        <Col span={6} key={i}>
          <Card bordered={false} style={{ borderRadius: 8 }}>
            <Statistic title={item.title} value={item.value} valueStyle={{ color: item.color, fontWeight: 700 }} />
          </Card>
        </Col>
      ))}
    </Row>
    <Card
      title="分润明细"
      extra={<Space><DatePicker.MonthPicker placeholder="选择月份" /><Button icon={<DownloadOutlined />}>导出</Button></Space>}
      bordered={false}
      style={{ borderRadius: 8 }}
    >
      <Table
        dataSource={commissions}
        size="small"
        pagination={false}
        columns={[
          { title: '代理商', dataIndex: 'agent', key: 'agent' },
          { title: '结算周期', dataIndex: 'period', key: 'period' },
          { title: '消费金额', dataIndex: 'revenue', key: 'revenue', render: v => `¥${v.toLocaleString()}` },
          { title: '分润比例', dataIndex: 'rate', key: 'rate' },
          { title: '分润金额', dataIndex: 'commission', key: 'commission', render: v => <span style={{ color: '#fa8c16', fontWeight: 600 }}>¥{v.toLocaleString()}</span> },
          {
            title: '状态', dataIndex: 'status', key: 'status',
            render: v => <Tag color={v === 'paid' ? 'success' : 'warning'}>{v === 'paid' ? '已结算' : '待结算'}</Tag>
          },
          {
            title: '操作', key: 'action',
            render: (_: any, r: any) => r.status === 'pending' ? <Button size="small" type="primary">确认结算</Button> : <Button size="small" disabled>已完成</Button>
          },
        ]}
      />
    </Card>
  </div>
);

export default Commission;
